import { Component, Input } from '@angular/core';
import { IPDFResource } from '@models';
import { FileTypesEnum } from '@enums';

@Component({
    selector: 'anp-pdf-item',
    templateUrl: './pdf-item.component.html',
    styleUrls: ['./pdf-item.component.scss'],
    standalone: false
})
export class PdfItemComponent {
  @Input() public pdf: IPDFResource;
  public fileType = FileTypesEnum;
}
